export const EDIT_STD_LOAN_MODAL = 'EDIT_STD_LOAN_MODAL';
export const LOAN_SUMMARY_MODAL = 'LOAN_SUMMARY_MODAL';
export const EDIT_MASTER_NOTE_MODAL = 'EDIT_MASTER_NOTE_MODAL';
export const LOAN_REPAYMENT_MODAL = 'LOAN_REPAYMENT_MODAL';
export const EDIT_BORROWER_MODAL = 'EDIT_BORROWER_MODAL';
export const DELETE_LOAN_MODAL = 'DELETE_LOAN_MODAL';
export const CANCEL_INSURANCE_MODAL = 'CANCEL_INSURANCE_MODAL';
export const LOSE_LOAN_MODAL = 'LOSE_LOAN_MODAL';
export const EXTENSION_MODAL = 'EXTENSION_MODAL';
export const HOLDBACK_RELEASE_MODAL = 'HOLDBACK_RELEASE_MODAL';
export const RENTAL_DSCR_MODAL = 'RENTAL_DSCR_MODAL';
export const BUILDRENT_CONVERSION_MODAL = 'BUILDRENT_CONVERSION_MODAL';
export const LINK_LOAN_WITH_BCLIENT_MODAL = 'LINK_LOAN_WITH_BCLIENT_MODAL';
export const REVERT_TO_APPROVED_MODAL = 'REVERT_TO_APPROVED_MODAL';
export const RESTORE_LOAN_MODAL = 'RESTORE_LOAN_MODAL';
export const PROPERTY_INSURANCE_MODAL = 'PROPERTY_INSURANCE_MODAL';
export const CHANGE_LOAN_LOANTYPE_MODAL = 'CHANGE_LOAN_LOANTYPE_MODAL';
export const TERMINATE_MASTERNOTE_MODAL = 'TERMINATE_MASTERNOTE_MODAL';
export const AUDIT_HISTORY_MODAL = 'AUDIT_HISTORY_MODAL';

export const setEditStdLoanModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_STD_LOAN_MODAL, state });
};

export const setLoanSummaryModal = (state) => (dispatch) => {
    dispatch({ type: LOAN_SUMMARY_MODAL, state });
};

export const setEditMasterNoteModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_MASTER_NOTE_MODAL, state });
};

export const setBorrowerEditModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_BORROWER_MODAL, state });
};

export const setRepaymentModal = (state) => (dispatch) => {
    dispatch({ type: LOAN_REPAYMENT_MODAL, state });
};

export const setDeleteLoanModal = (state) => (dispatch) => {
    dispatch({ type: DELETE_LOAN_MODAL, state });
};

export const setCancelInsuranceModal = (state) => (dispatch) => {
    dispatch({ type: CANCEL_INSURANCE_MODAL, state });
};

export const setLoseLoanModal = (state) => (dispatch) => {
    dispatch({ type: LOSE_LOAN_MODAL, state });
};

export const setExtensionModal = (state) => (dispatch) => {
    dispatch({ type: EXTENSION_MODAL, state });
};

export const setReleaseHoldbackModal = (state) => (dispatch) => {
    dispatch({ type: HOLDBACK_RELEASE_MODAL, state });
};

export const setRentalDscrModal = (state) => (dispatch) => {
    dispatch({ type: RENTAL_DSCR_MODAL, state });
};

export const setBuildRentConversionModal = (state) => (dispatch) => {
    dispatch({ type: BUILDRENT_CONVERSION_MODAL, state });
};

export const setLinkLoanWithBClientModal = (state) => (dispatch) => {
    dispatch({ type: LINK_LOAN_WITH_BCLIENT_MODAL, state });
};

export const setRevertToApprovedModal = (state) => (dispatch) => {
    dispatch({ type: REVERT_TO_APPROVED_MODAL, state });
};

export const setRestoreLoanModal = (state) => (dispatch) => {
    dispatch({ type: RESTORE_LOAN_MODAL, state });
};

export const setPropertyInsuranceModal = (state) => (dispatch) => {
    dispatch({ type: PROPERTY_INSURANCE_MODAL, state });
};

export const setChangeLoanTypeModal = (state) => (dispatch) => {
    dispatch({ type: CHANGE_LOAN_LOANTYPE_MODAL, state });
};

export const setTerminateMasterNoteModal = (state) => (dispatch) => {
    dispatch({ type: TERMINATE_MASTERNOTE_MODAL, state });
};

export const setAuditHistoryModal = (state) => (dispatch) => {
    dispatch({ type: AUDIT_HISTORY_MODAL, state });
};

export default {
    EDIT_STD_LOAN_MODAL,
    LOAN_SUMMARY_MODAL,
    EDIT_MASTER_NOTE_MODAL,
    LOAN_REPAYMENT_MODAL,
    EDIT_BORROWER_MODAL,
    DELETE_LOAN_MODAL,
    CANCEL_INSURANCE_MODAL,
    LOSE_LOAN_MODAL,
    EXTENSION_MODAL,
    HOLDBACK_RELEASE_MODAL,
    RENTAL_DSCR_MODAL,
    BUILDRENT_CONVERSION_MODAL,
    LINK_LOAN_WITH_BCLIENT_MODAL,
    REVERT_TO_APPROVED_MODAL,
    RESTORE_LOAN_MODAL,
    PROPERTY_INSURANCE_MODAL,
    CHANGE_LOAN_LOANTYPE_MODAL,
    TERMINATE_MASTERNOTE_MODAL,
    AUDIT_HISTORY_MODAL,
    setEditStdLoanModal,
    setLoanSummaryModal,
    setEditMasterNoteModal,
    setBorrowerEditModal,
    setRepaymentModal,
    setDeleteLoanModal,
    setCancelInsuranceModal,
    setLoseLoanModal,
    setExtensionModal,
    setReleaseHoldbackModal,
    setRentalDscrModal,
    setBuildRentConversionModal,
    setLinkLoanWithBClientModal,
    setRevertToApprovedModal,
    setRestoreLoanModal,
    setPropertyInsuranceModal,
    setChangeLoanTypeModal,
    setTerminateMasterNoteModal,
    setAuditHistoryModal,
};
